// Standard library imports
import React, { useState } from 'react';
// Internal module imports
import TabsComponent from '../../../../components/Tabs/Tabs';
import AfrrLogs from './AfrrLogs';
import PowerLogs from './PowerLogs';
import { NumberParam } from 'use-query-params';
import { useQueryParamWithDefault } from '../../../../hooks';

const CommandLog = ({ eicCodeOptions, cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('subTab', NumberParam, 0, cId);
    let tabs = [
        {
            name: 'AFRR Logs',
            component: (
                <>
                    <AfrrLogs eicCodeOptions={eicCodeOptions} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'AFRR Power Logs',
            component: (
                <>
                    <PowerLogs eicCodeOptions={eicCodeOptions} />
                </>
            ),
            tabId: 1,
        },
    ];

    return (
        <div className=" ventilation">
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default CommandLog;
